<template>
    <div
        id="update-payment-status-modal"
        bg-close="false"
        esc-close="false"
        class="update-payment-status-modal uk-flex-top"
        :container="container"
        uk-modal
    >
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-border-rounded">
            <div class="uk-modal-header uk-border-rounded">
                <button
                    ref="close-button"
                    class="uk-modal-close-default"
                    type="button"
                    uk-close
                    @click="cancelModal"
                />
                <h4 class="message">Update Job ID {{ buffer.payment.jobNumber }} Payment Status</h4>
                <div
                    id="save-quote-form"
                    class="uk-display-block uk-grid-small uk-margin-large-top"
                    uk-grid
                >
                    <div
                        id="save-quote-api-container"
                        class="uk-grid-small uk-child-width-expand@s uk-margin-small-top uk-display-block"
                        uk-grid
                    >
                        <div class="uk-margin-remove-bottom uk-align-center">
                            <div
                                id="update-payment-status"
                            >
                                <form-wrapper
                                    :validator="$v.buffer.payment"
                                >
                                    <select-field
                                        v-model="buffer.payment.status"
                                        placeholder="Payment Status"
                                        name="paymentStatus"
                                        :options="paymentStatuses"
                                        :v="$v.buffer.payment.status"
                                        label="Payment Status"
                                        :show-error-on-blur-only="true"
                                    />
                                    <checkbox-field
                                        v-model="buffer.notifyClient"
                                        label="Send a new receipt to the customer"
                                        name="notifyClient"
                                        :show-error-on-blur-only="true"
                                    />
                                </form-wrapper>
                            </div>
                        </div>
                        <div class="uk-flex uk-flex-center">
                            <div>
                                <button
                                    type="button"
                                    class="uk-button uk-button-default uk-align-center"
                                    @click="cancelModal"
                                >
                                    <span>Cancel</span>
                                </button>
                            </div>
                            <div class="uk-margin-left">
                                <button
                                    type="button"
                                    class="uk-button uk-button-primary uk-align-center"
                                    @click="updatePayment"
                                >
                                    <span>Update</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from 'vuex';
import { updatePaymentRequest } from '../../helpers/api'

const SelectField = () => import("@strangeanimals/common-vue-components/src/components/fields/SelectField");
const CheckboxField = () => import("@strangeanimals/common-vue-components/src/components/fields/CheckboxField");

export default {
    components: { SelectField, CheckboxField },
    props: {
        paymentStatuses: {
            type: Object,
            default: function () {
                return {};
            }
        },
        container: {
            type: [String, Boolean],
            default: false
        },
    },
    data: function () {
        return {
            buffer: {
                payment: {
                    id: '',
                    status: '',
                    jobNumber: '',
                },
                notifyClient: false,
            }
        };
    },
    validations: {
        buffer: {
            payment: {
                id: { required },
                status: { required },
            },
            notifyClient: { required },
        }
    },
    mounted() {
        this.resetForm();
    },
    methods: {
        ...mapActions({
            updatePaymentStatus: 'updatePaymentStatus',
        }),
        showModal(data) {
            this.buffer.payment = data;
            this.$uikit.modal('#update-payment-status-modal').show();
        },
        cancelModal() {
            this.$uikit.modal('#update-payment-status-modal').hide();
            this.resetForm();
        },
        validateForm() {
            return !this.$v.buffer.user.$invalid;
        },
        updatePayment() {
            const data = {
                id: this.buffer.payment.id,
                status: this.buffer.payment.status,
                payment_type: this.buffer.payment.paymentType,
                notify_client: this.buffer.notifyClient,
            };
            updatePaymentRequest(data).then((response) => {
                if (response.body) {
                    this.updatePaymentStatus({
                        id: this.buffer.payment.id,
                        status: this.buffer.payment.status
                    });
                    this.$emit('setSystemMessage', ['Payment status updated.'], true);
                }
                else {
                    this.$emit('setSystemMessage', ['An error was encountered while updating payment status.'], false);
                }
            }).finally(() => {
                this.resetForm();
            });

            this.$uikit.modal('#update-payment-status-modal').hide();
        },
        resetForm() {
            this.buffer = {
                payment: {
                    id: '',
                    status: '',
                    jobNumber: '',
                },
                notifyClient: false,
            };
        }
    },
}
</script>